import { createDraftContext } from './Draft'

export const RequestWizardDraft = createDraftContext()
